import { ComponentType } from 'react';
import { Route, Switch } from 'react-router-dom';
import { AUTH_PATHS } from '../../routes/auth.routes';
import SignUpPage from '../create-account/SignUpPage';
import Login from './Login';
import RecoverPassword from './RecoverPassword';
import ResetPassword from './ResetPassword';
import AuthShell from './components/AuthShell';

interface AuthFlowRoute {
  component: ComponentType;
  paths: (typeof AUTH_PATHS)[keyof typeof AUTH_PATHS];
}

const AUTH_FLOW_ROUTES: AuthFlowRoute[] = [
  { component: ResetPassword, paths: AUTH_PATHS.resetPassword },
  { component: RecoverPassword, paths: AUTH_PATHS.recoverPassword },
  { component: Login, paths: AUTH_PATHS.login },
  { component: SignUpPage, paths: AUTH_PATHS.storeSignUp },
];

const AuthFlow = () => (
  <AuthShell>
    <Switch>
      {AUTH_FLOW_ROUTES.map(({ component, paths }) => (
        <Route
          key={paths.basePaths[0]}
          exact
          path={[...paths.brandPaths, ...paths.basePaths]}
          component={component}
        />
      ))}
    </Switch>
  </AuthShell>
);

export default AuthFlow;
